import React from "react";
import Tooltip from "./Tooltip";

function SelectInput({ customInput, data }) {
  const { label, name, value, action, tooltipBool, tooltipText, disabled } =
    customInput;

  return (
    <>
      <label htmlFor={name}>
        {label}
        {tooltipBool === true && <Tooltip text={tooltipText}></Tooltip>}
      </label>
      <select name={name} value={value} onChange={action} disabled={disabled}>
        <option key="placeholder" disabled defaultChecked value="">
          Select an option
        </option>

        {data.map((option) => {
          if (option.value === "" && option.text === "") {
            return <option key="placeholder" hidden disabled value=""></option>;
          } else {
            return (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled ?? false}
              >
                {option.text}
              </option>
            );
          }
        })}
      </select>
    </>
  );
}

export default SelectInput;
